"use strict";

module.exports = function (value) {
	// eslint-disable-next-line no-self-compare
	return value !== value;
};



//////////////////
// WEBPACK FOOTER
// D:/cpc/sinocc.web/web.X6/www/x6.ng2/~/es5-ext/number/is-nan/shim.js
// module id = ../../../../es5-ext/number/is-nan/shim.js
// module chunks = 4